import { LastLoginInfoGetters } from './partials/LastLoginInfo'

export const AuthenticationGetters = {
  ...LastLoginInfoGetters,

  isAuthenticationByMagicLinkEnabled: state => state.multifactorAuthenticationSettings?.strategies?.magic_link === true,
  isAuthenticationByOTPViaEmailEnabled: state => state.multifactorAuthenticationSettings?.strategies?.otp_by_email === true,
  isAuthenticationByOTPViaTextMessageEnabled: state => state.multifactorAuthenticationSettings?.strategies?.otp_by_text_message === true,
  isAuthenticationByTOTPEnabled: state => state.multifactorAuthenticationSettings?.strategies?.totp === true,
  isMultifactorAuthenticationEnabled: state => state.multifactorAuthenticationSettings?.enabled === true,
  multifactorAuthenticationStrategies: state => state.multifactorAuthenticationSettings?.strategies || {},
}
